import { createSlice } from '@reduxjs/toolkit';

const notificationSlice = createSlice({
    name: 'notification',
    initialState: {
        isNewNotification: true
    },
    reducers: {
        setIsNewNotification: (state, action) => {
            state.isNewNotification = action.payload
        }
    },
});

export const { setIsNewNotification } = notificationSlice.actions;
export const selectIsNewNotification = (state) => state.notification.isNewNotification;
export default notificationSlice.reducer;